import type { Strings } from "../i18n/strings";
import type { MoonError } from "../lib/types";

interface Props {
  t: Strings;
  kind: MoonError;
  onRetry: () => void;
  onBack: () => void;
}

// AI 실패면(기술적 실패) — 평문 + 재시도. ★위기 안전면과 별개: 시적 위로 없음, 위기 리소스로 보내지 않음.
// 더미(예시) 편지를 진짜인 척 띄우지 않는다 — 실패는 실패로 보이게.
const MSG: Record<MoonError, keyof Strings> = {
  unavailable: "errUnavailable",
  timeout: "errTimeout",
  offline: "errOffline",
  busy: "errBusy",
};

export default function ErrorCard({ t, kind, onRetry, onBack }: Props) {
  return (
    <div className="screen error-screen">
      <div className="topbar">
        <button className="navbtn" onClick={onBack}>
          ← {t.back}
        </button>
        <span />
      </div>
      <div className="error-body">
        <p className="error-msg">{t[MSG[kind]]}</p>
        <button className="btn-primary error-retry" onClick={onRetry}>
          {t.retry}
        </button>
      </div>
    </div>
  );
}
